import apiFetch from '../../apiFetch'

export default function (limpiezaCorralsAnadidas, token) {
  return apiFetch({endPoint: `Bioseguridad/getCorrales`, method: 'POST', body: limpiezaCorralsAnadidas, token: token})
}
